import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import ReactImageMagnify from 'react-image-magnify';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import _ from 'lodash';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { enlargedWidthOf, useImageBox } from "./imageBox";
import { getImageDataByFileName } from "../../actions";
const S3_BUCKET_BASE_URL = process.env.REACT_APP_S3_BUCKET_BASE_URL;

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'flex-start',
      paddingTop: '20px',
      justifyContent: "center",
      width: 'fit-content',
      maxWidth: '100%',
      margin: '0 auto',
    },
    thumbnailSliderWrapper: {
      position: 'relative',
      width: 100,
      marginRight: 16,
    },
    thumbnailSlider: {
      width: 100,
      marginRight: 16,
      '.slick-list': {
        height: "440px",
        overflow: 'hidden',
      },
    },
    thumbnail: {
      width: '100%',
      cursor: 'pointer',
      border: '2px solid transparent',
      marginBottom: 8,
      '&:hover': {
        border: '2px solid #ccc',
      },
    },
    imageMagnify: {
      flex: '0 0 auto',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    magnifyWrapper: {
      position: 'relative',
      display: 'flex',
      width: 'fit-content',
      maxWidth: '100%',
      margin: '0 auto',
    },
    magnifyPlaceholder: {
      position: 'relative',
      top: 0,
      marginLeft: 10,
      width: '795px',
      minHeight: '45px',
      border: '2px dashed #ccc',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#333',
      fontSize: '14px',
      zIndex: 1,
      pointerEvents: 'none',
    },
    magnifyPlaceholderHidden: {
      visibility: 'hidden',
      borderColor: 'transparent',
      color: 'transparent',
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      height: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
      marginRight: 0,
      marginLeft: 0,
      whiteSpace: 'nowrap',
      flex: '0 0 auto',
    },
    arrow: {
      position: 'absolute',
      zIndex: 2,
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      borderRadius: '50%',
      padding: '5px',
      cursor: 'pointer',
      left: '33%',
    },
    arrowUp: {
      top: '-55px',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    arrowDown: {
      bottom: '-40px',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    noImageContainer: {
      width: '795px',
      minHeight: '20px',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      marginBottom: theme.spacing(8),
    },
    imageButtonRow: {
      width: 300,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'nowrap',
      gap: theme.spacing(1.5),
    },
  })
);

const CustomArrowUp = ({ className, onClick }) => {
  const classes = useStyles();
  return (
    <ExpandLessIcon className={`${classes.arrow} ${className}`} onClick={onClick} style={{marginTop: "-30px"}} />
  );
};

const CustomArrowDown = ({ className, onClick }) => {
  const classes = useStyles();
  return (
    <ExpandMoreIcon className={`${classes.arrow} ${className}`} onClick={onClick} />
  );
};

const ReportMagnify = ({
  pageTopLoader,
  viewer,
  reportImageDataByOthers,
  getImageDataByFileName,
  viewerImageData,
  onSetNumOfImage,
}) => {
  const classes = useStyles();
  const sliderRef = useRef(null);
  const containerRef = useRef(null); // コンテナの参照を取得
  const [selectedImage, setSelectedImage] = useState([]);
  const [isZoomed, setIsZoomed] = useState(false);
  const [images, setImages] = useState([]);
  const imageBox = useImageBox(selectedImage.small);
  const [isImageExist, setImageExist] = useState(false);
  const [othersDisplay, setOthersDisplay] = useState(false);

  useEffect(() => {
    if (viewer.length > 0) {
      let imageUrls = {}, imageUrlsArray = [];

      // case: no report image and no photo
      if (!viewer[0]["fileName"] && reportImageDataByOthers.length === 0) {
        return;
      }

      // case: no report image but there is others taken photos
      if (!viewer[0]["fileName"] && reportImageDataByOthers.length > 0) {
        const fileName = decodeURIComponent(reportImageDataByOthers[0]["file_name"].split(".")[0]);
        getImageDataByFileName(fileName);
        return;
      }
      const uniquePhotoData = _.uniqWith(viewer[0].allPhotoUrl, _.isEqual);
      const imageUrlArray = uniquePhotoData;
      _.each(imageUrlArray, function(photoData) {
        const isFullImageUrl = /^https?:\/\//i.test(photoData);
        let imageUrl = photoData;
        if (!isFullImageUrl) {
          imageUrl = photoData.includes("+")
            ? photoData.replace("+", "%2B")
            : photoData;
          imageUrl = `${S3_BUCKET_BASE_URL}/${imageUrl}`;
        }
        imageUrls.small = imageUrl;
        imageUrls.large = imageUrl;
        imageUrls.fileName = photoData.split("Report/")[1];
        imageUrlsArray.push(imageUrls);
        imageUrls = {};
      });
      setImages(imageUrlsArray);
      onSetNumOfImage(imageUrlsArray.length);
      setImageExist(true);
    }
  }, [viewer]);

  useEffect(() => {
    if (viewerImageData.length > 0) {
      let imageUrls = {}, imageUrlsArray = [];
      _.each(viewerImageData, function(photoData) {
        let imageObjectKey = photoData.object_key;
        if (imageObjectKey.includes("+")) {
          imageObjectKey = imageObjectKey.replace("+", "%2B");
        }
        imageUrls.small = `${S3_BUCKET_BASE_URL}/${imageObjectKey}`;
        imageUrls.large = `${S3_BUCKET_BASE_URL}/${imageObjectKey}`;
        imageUrls.fileName = photoData.file_name;
        imageUrlsArray.push(imageUrls);
        imageUrls = {};
      });
      setImages(imageUrlsArray);
      onSetNumOfImage(imageUrlsArray.length);
      setImageExist(true);
      setOthersDisplay(true);
    }
  }, [viewerImageData]);

  useEffect(() => {
    if (images.length > 0) {
      setSelectedImage(images[0]);

      const handleWheel = (e) => {
        e.preventDefault();
        if (e.deltaY < 0) {
          sliderRef.current.slickPrev();
        } else {
          sliderRef.current.slickNext();
        }
      };

      const containerElement = containerRef.current; // コンテナ要素を取得

      if (containerElement) {
        containerElement.addEventListener('wheel', handleWheel);
      }

      return () => {
        if (containerElement) {
          containerElement.removeEventListener('wheel', handleWheel);
        }
      };
    }
  }, [images]);

  const settings = {
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    prevArrow: <CustomArrowUp />,
    nextArrow: <CustomArrowDown />,
  };

  const handleThumbnailClick = (index) => {
    setSelectedImage(images[index]);
  };

  const handleMouseEnter = () => {
    setIsZoomed(true);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
  };

  const openImageInNewTab = (url) => {
    window.open(url, '_blank');
  };
  return (
    <>
    <div ref={containerRef} className={classes.container}>
      {isImageExist &&
      <>
      <div className={classes.thumbnailSliderWrapper}>
        <CustomArrowUp onClick={() => sliderRef.current.slickPrev()} />
        <div className={classes.thumbnailSlider} style={{ height: '450px', overflow: 'hidden' }}>
          <Slider ref={sliderRef} {...settings}>
            {images.map((image, index) => (
              <div key={index} onClick={() => handleThumbnailClick(index)}>
                <img
                  src={image.small}
                  alt={`Thumbnail ${index}`}
                  className={classes.thumbnail}
                />
              </div>
            ))}
          </Slider>
        </div>
        <CustomArrowDown onClick={() => sliderRef.current.slickNext()} />
      </div>
      <div className={classes.imageMagnify}>
        <div className={classes.magnifyWrapper}>
          <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <ReactImageMagnify
              {...{
                smallImage: {
                  alt: 'Selected Image',
                  isFluidWidth: false,
                  width: imageBox.width,
                  height: imageBox.height,
                  src: selectedImage.small,
                },
                largeImage: {
                  src: selectedImage.large,
                  width: imageBox.naturalWidth,
                  height: imageBox.naturalHeight,
                },
                enlargedImageContainerDimensions: {
                  width: "265%",
                  height: "100%",
                },
              }}
            />
          </div>
          <div
            className={`${classes.magnifyPlaceholder} ${isZoomed ? classes.magnifyPlaceholderHidden : ''}`}
            style={{ width: enlargedWidthOf(imageBox) }}
          >
            画像にマウスを合わせると拡大が表示されます
          </div>
        </div>
        <div className={classes.imageButtonRow}>
          <Button
            className={classes.dataBtn}
            variant="contained"
            onClick={() => openImageInNewTab(selectedImage.large)}
          >
            元画像を開く
          </Button>
          <Button
            className={classes.dataBtn}
            variant="contained"
            href={`https://www.google.com/maps?q=${viewer[0]["latitude"]},${viewer[0]["longitude"]}&z=16&hl=ja`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ paddingTop: 8 }}
          >
            Google Mapを開く
          </Button>
        </div>
      </div>
      </>
      }
    </div>
    </>
  );
};

ReportMagnify.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.app.pageTopLoader,
  reportImageDataByOthers: state.report.reportImageDataByOthers,
  viewerImageData: state.viewer.viewerImageData,
});

const mapDispatchToProps = (dispatch) => ({
  getImageDataByFileName: (param) => dispatch(getImageDataByFileName(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(null, { withTheme: true })(ReportMagnify));
